module.exports = "<footer class=\"app-footer\">\n  <span><a href=\"http://tshtx.uz\">CLICK&МВД</a> &copy; {{year}}.</span>\n\n</footer>\n"


//////////////////
// WEBPACK FOOTER
// D:/Projects/mvdclick/frontend/src/app/components/app-footer/app-footer.component.html
// module id = ../../../../../src/app/components/app-footer/app-footer.component.html
// module chunks = main